<template>
	<div>
		<Header />
		<TitlePage />
		
		<SearchDesktop />
		<b-row :no-gutters="isMobile">
			<b-col cols="12" class="wrap-link-more" v-if="!isMobile">
              <ul class="ul-link-more text-center">
                <li @click="gotoFAQ">
                  <router-link
                    id="frequentlyAskedQuestions"
                    :to="
                      $i18nRoute({ name: 'faq' }) +
                      '#frequently-asked-questions'
                    "
                    >{{ $t("home.frequentlyAskedQuestions") }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    id="termsOfuse"
                    :to="$i18nRoute({ name: 'faq' }) + '#terms-of-use'"
                    >{{ $t("home.termsOfuse") }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    id="privacyPolicy"
                    :to="$i18nRoute({ name: 'faq' }) + '#privacy-policy'"
                    >{{ $t("home.privacyPolicy") }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    id="listingPolicy"
                    :to="$i18nRoute({ name: 'faq' }) + '#listing-policy'"
                    >{{ $t("home.listingPolicy") }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    id="advertise-withus-button"
                    :to="$i18nRoute({ name: 'ads' })"
                    target="_blank"
                    >{{ $t("home.advertiseWithUs") }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    id="contactUs"
                    :to="$i18nRoute({ name: 'faq' }) + '#contact-us'"
                    >{{ $t("home.contactUs") }}</router-link
                  >
                </li>
                <li>
                  <div
                    id="contactUs"
                    style="cursor: pointer;"
                    @click="disclaimer=true"
                    >{{ $t("disclaimer") }}</div
                  >
                </li>
				<li>
                   <router-link
                    id="Activities"
                    :to="$i18nRoute({ name: 'topics/how-to-post-listing' })"
                    target="_blank"
                    >{{ $t("Activities") }}</router-link
                  >
                </li>
              </ul>
            </b-col>
			<b-col cols="12" class="wrap-link-more" v-else>
              <ul class="ul-link-more text-center d-flex flex-row align-self-start align-items-start justify-content-around flex-wrap">
                <div class="ul-link-div">
                  <li>
                    <router-link
                      id="frequentlyAskedQuestions"
                      :to="
                        $i18nRoute({ name: 'faq' }) +
                        '#frequently-asked-questions'
                      "
                    >
                      {{ $t("home.frequentlyAskedQuestions") }}
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      id="termsOfuse"
                      :to="$i18nRoute({ name: 'faq' }) + '#terms-of-use'"
                      >{{ $t("home.termsOfuse") }}</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      id="privacyPolicy"
                      :to="$i18nRoute({ name: 'faq' }) + '#privacy-policy'"
                      >{{ $t("home.privacyPolicy") }}</router-link
                    >
                  </li>
                  <li>
                  <div
                    id="contactUs"
                    style="cursor: pointer;"
                    @click="disclaimer=true"
                    >{{ $t("disclaimer") }}</div
                  >
                </li>
                </div>
                <div class="ul-link-div">
                <li>
                  <router-link
                    id="listingPolicy"
                    :to="$i18nRoute({ name: 'faq' }) + '#listing-policy'"
                    >{{ $t("home.listingPolicy") }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    id="advertise-withus-button"
                    :to="$i18nRoute({ name: 'ads' })"
                    >{{ $t("home.advertiseWithUs") }}</router-link
                  >
                </li>
                <li>
                  <router-link
                    id="contactUs"
                    :to="$i18nRoute({ name: 'faq' }) + '#contact-us'"
                    >{{ $t("home.contactUs") }}</router-link
                  >
                </li>
				<li>
                   <router-link
                    id="Activities"
                    :to="$i18nRoute({ name: 'topics/how-to-post-listing' })"
                    target="_blank"
                    >{{ $t("Activities") }}</router-link
                  >
                </li>
                </div>
              </ul>
            </b-col>
		</b-row>
		<Footer  :adsFooter="adsFooter"/>
		<b-modal
			id="disclaimer"
			size="lg"
			v-model="disclaimer"
			centered
			hide-header
			hide-footer
			>
			<div @click="disclaimer = false" class="close-modal text-right" style="cursor: pointer;"><CloseIcon /></div>
			<p class="text mt-20">
				{{$t('ข้อสงวนสิทธิ์ (Disclaimers)')}}
				<br />
			</p>
			<p class="text" style="font-size: 16px; text-align: left; overflow-wrap: break-word;">
				 ข้อมูลและเนื้อหาทั้งหมดที่ปรากฏใน <a href="marketplace.khaosod.co.th" style="color:#444;text-transform: unset!important;">marketplace.khaosod.co.th</a> นี้ อยู่ภายใต้ลิขสิทธิ์ของบริษัท อินแฮนเซอร์ (ประเทศไทย) จำกัด เป็นผู้ดูแลรับผิดชอบทั้งหมด หากพบปัญหามีข้อสงสัย แจ้งแก้ไขข้อมูล ลงโฆษณา หรือประสานงานใดๆ กรุณาติดต่อที่ <a href="marketplace.khaosod.co.th/th/faq/#contact-us" style="color:#444;text-transform: unset!important;">https://marketplace.khaosod.co.th/th/faq/#contact-us</a><br /><br />
          ทั้งนี้ บริษัทมติชนจำกัดมหาชน ไม่มีส่วนเกี่ยวข้องกับข้อมูลและเนื้อหาดังกล่าว ไม่มีข้อผูกพันสัญญา หรือข้อตกลงใดๆ กับการใช้บริการของท่าน และไม่รับผิดชอบต่อความเสียหายใดๆ ที่เกิดขึ้น ไม่ว่าโดยทางตรงหรือทางอ้อมอันเนื่องมาจากข้อมูล สินค้า หรือ บริการที่เสนอบนเว็บไซต์ <a href="marketplace.khaosod.co.th" style="color:#444;text-transform: unset!important;">marketplace.khaosod.co.th</a> นี้ ทุกกรณี
				<br />
			</p>
		</b-modal>
	</div>
	
            <!-- data-ad-format="rectangle" -->
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import Header from '@/components/ui/header';
import Footer from '@/components/ui/footer';
import TitlePage from '@/components/ui/titlePage';
import SearchDesktop from '@/components/search/SearchDesktop';
import CloseIcon from "vue-material-design-icons/Close.vue";
export default {
	components: {
		Header,
		Footer,
		TitlePage,
		SearchDesktop,
		CloseIcon
	},
	data() {
		return {
			adsFooter: null,
			disclaimer:false
		}
	},
	 computed: {
		...mapGetters("UserController", [ "isMobile"]),
	 },
	created(){
		let locationId = 9;
		if (
			(this.$router.history.current.path == "/th/search/" ||
				this.$router.history.current.path == "/en/search/" ) &&
			((this.dataSearch && this.dataSearch.id == 1) || this.categoryId == 1)
			) {
				locationId = 14;
			}
			if (
			(this.$router.history.current.path == "/th/search/" ||
				this.$router.history.current.path == "/en/search/" ) &&
			((this.dataSearch && this.dataSearch.id == 2) || this.categoryId == 2)
			) {
				locationId = 23;
			}
			
			if (
			(this.$router.history.current.path == "/th/search/" ||
				this.$router.history.current.path == "/en/search/")  &&
			((this.dataSearch && (this.dataSearch.id == 3 || this.dataSearch.id == 32)) || this.categoryId == 3)
			) {
				locationId = 32;
			}
		
			if (
			(this.$router.history.current.path == "/th/search/" ||
				this.$router.history.current.path == "/en/search/" ) &&
			((this.dataSearch && this.dataSearch.id == 4) || this.categoryId == 4)
			) {
				locationId = 41;
			}
			
		if(this.isMobile){
			locationId=49;
		}
		console.log("locationId",locationId)
		this.getFooterAds(locationId);
	},
	methods:{
		...mapActions("AdsController", [
			"GETADS_FOR_PUBLIC_WEBSITE",
			"CLICK_BANNERADS"
		]),
		gotoFAQ() {
			this.$store.dispatch("FavouriteController/GET_FAQ", false);
		},
		getFooterAds(locationId){
			console.log("locationId",locationId);
			this.GETADS_FOR_PUBLIC_WEBSITE({
				id: locationId
			}).then(({ data }) => {
				console.log("data",data)
			if (data) {
				this.adsFooter = data;
				this.$forceUpdate();
			}
			});
		},
	},
	destroyed(){
		console.log("destroyed search")
		this.adsFooter=null
	}
};
</script>

<style lang="scss">

.wrap-link-more {
	> ul {
	  padding: 0;
	  margin-top: 70px;
	  &.ul-link-more {
		list-style: none;
		> li {
		  display: inline-block;
		  padding-right: 12px;
		  margin-right: 12px;
		  border-right: 1px solid #626262;
		  &:last-child {
			margin-right: 0;
			border-right: 0;
		  }
		  > a {
			font-size: 16px;
			@media (max-width: 992px) {
			  font-size: 18px;
			}
			color: #626262;
		  }
		}
	  }
	}
  }
  #modal-wellcome {
	.modal-dialog {
	  max-width: 540px;
	  .modal-content {
		.modal-body {
		  text-align: center;
		  padding: 25px;
		  .text {
			font-family: "Prompt";
			font-size: 20px;
			font-weight: normal;
			color: #626262;
		  }
		}
	  }
	}
	.close-modal {
	  position: absolute;
	  top: 10px;
	  right: 15px;
	  font-size: 20px;
	  &:hover {
		cursor: pointer;
	  }
	}
  }
  @media (max-width: 768px) {

	.wrap-link-more {
	  > ul {
		&.ul-link-more {
		  display: flex;
		  flex-wrap: wrap;
		  justify-content: center;
		  // width: 335px;
		  // margin-right: auto;
		  margin-left: auto;
		  .ul-link-div{
			> li {
			  padding-right: 0;
			  margin-right: 0;
			  border-right: 0;
			  text-align: left;
			  // width: 50%;
			  > a {
				display: list-item;
				font-size: 18px;
				color: #626262;
				// list-style-type: disc;
			  }
			}
		  }
		}
	  }
	}
	
  }
  </style>
